import React from 'react';
import { Link } from 'react-router-dom';
export function LogoSection() {
  return <div className="flex-shrink-0 flex items-center" data-id="element-422">
      <Link to="/" data-id="element-423">
        <img className="h-16 w-auto" src="https://cdn.magicpatterns.com/uploads/vAEpLiGwZwCFYgjmhhMBxx/precision_pro_sprayers_header_cropped.png" alt="Precision Pro Sprayers" data-id="element-424" />
      </Link>
    </div>;
}